import React, { useEffect, useState } from 'react'
import '../../assets/styles/DashboardStyling.css'
import Avatar from '@mui/material/Avatar';
import { Button, List, Spin, notification, Input } from 'antd';
import { Card } from 'react-bootstrap';
import { useRecoilState, useRecoilValue } from 'recoil';
import { currentConfiguration } from '../../../../../service/memory/recoil/configurationstore';
import ConfigurationConstants from '../../../../utils/configurationconstants';
import IntentType from '../../../../../intentexecutor/utils/IntentType';
import { executeIntent } from '../../../../utils/IntentExecutor';
import CustomModal from '../../../../../components/generic/custommodal/CustomModal';
import SecondaryButton from '../../../../../components/generic/buttons/SecondaryButton';
import PrimaryButton from '../../../../../components/generic/buttons/PrimaryButton';
import StrapiService from '../../../../articles/StrapiService';
import { useReadMemory } from '../../../../generic/hooks/useReadMemory';
import MemoryType from '../../../../../service/memory/enum/MemoryType';
import { birthdayNotificationpayload } from '../../../../generic/workforcesuggestion/utils/notificationpayload';
import { useGetOrgIdentifier } from '../../../../generic/hooks/useGetOrgIdentifier';
import ErrorNotificationComponent from '../../../../../components/generic/error/ErrorNotificationComponent';
import { publishEvent } from '../../../../../components/generic/EventPublisher';
import { convertDateToEODTimestamp, convertDateToSODTimestamp, getCurrentTimeZone } from '../../../../../utils/dateutils';
import IntentExecutor from '../../../../../intentexecutor/IntentExecutor';
import { getApiUrl } from '../../../../../service/network/UrlMapper';
import { strings } from '../../../../utils/strings';
import { RoleToLinkMapper } from '../../../../utils/UrlUtils';
import { useNavigate } from 'react-router';
import { useGetRole } from '../../../../generic/hooks/useGetRole';
import { dateRangeRecoil, isDefaultDateRangeRecoil } from '../../../../../components/recoil/dateRangeRecoil';
import { performPostRequest } from '../../../../../service/network/NetworkService';
import { teamList } from '../../../../../components/recoil/teamsRecoil';
import apiService from '../../../../../service/apiservice/apiService';
import Initials from '../../../../../components/generic/generateinitials/Initials';

const { TextArea } = Input;

const StayConnected = () => {
    const user = useReadMemory(MemoryType.USER)
    const organizationIdentifier = useGetOrgIdentifier();
    const role = useGetRole();
    const navigate = useNavigate();
    const teams = useRecoilValue(teamList);
    const dateRange = useRecoilValue(dateRangeRecoil);
    const isDefaultDateRange = useRecoilValue(isDefaultDateRangeRecoil);
    const [configuration,] = useRecoilState(currentConfiguration);
    const [showWishingBtn, setShowWishingBtn] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [receiver, setReceiver] = useState({});
    const [mailSubject, setMailSubject] = useState("")
    const [mailBody, setMailBody] = useState("")
    const [mailSignature, setMailSignature] = useState("")
    const [fcmBody, setFcmBody] = useState("")
    const [fcmTitle, setFcmTitle] = useState("")
    const [smsMessage, setSmsMessage] = useState("")
    const [appId, setAppId] = useState("")
    const [clickAction, setClickAction] = useState("")
    const [sentWishes, setSentWishes] = useState([])
    const [mailBodyLoading, setMailBodyLoading] = useState(false)
    const [refresh, setRefresh] = useState(true)
    const [occasionData, setOccasionData] = useState([]);
    const [occasionType, setOccasionType] = useState("");
    const [loading, setLoading] = useState(false);
    const [preferences, setPreferences] = useState(null);
    const strapiService = new StrapiService();

    const occasion = {
        birthday: {
            label: "Birthday",
            buttonLabel: "Say Happy Birthday",
            modalTitle: "a warm and bright birthday!",
            eventType: "niramaya.birthday.wish",
            template: "birthday-wish-template",
        },
        anniversary: {
            label: "Anniversary",
            buttonLabel: "Say Happy Anniversary",
            modalTitle: "a special work anniversary with appreciation and good wishes!",
            eventType: "niramaya.anniversary.wish",
            template: "anniversary-wish-template",
        }
    }

    const filterUpcomingBirthdays = (dates) => {
        if (!Array.isArray(dates)) return [];
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Create a set of valid (month-day) combinations for past 7 days
        const validDays = new Set();
        for (let i = 0; i < 7; i++) {
            const d = new Date(today);
            d.setDate(today.getDate() - i);
            validDays.add(`${d.getMonth()}-${d.getDate()}`);
        }

        return dates.filter(dateObj => {
            if (!dateObj?.occasionDate) return false;
            const date = new Date(dateObj.occasionDate);
            const key = `${date.getMonth()}-${date.getDate()}`;
            return validDays.has(key);
        });
    };

    const upcomingBirthdays = isDefaultDateRange ? filterUpcomingBirthdays(occasionData) : occasionData;

    const sortedBirthDays = upcomingBirthdays?.sort((a, b) => {
        let dateA = new Date(a.occasionDate);
        let dateB = new Date(b.occasionDate);

        let monthDayA = (dateA.getMonth() + 1) * 100 + dateA.getDate();
        let monthDayB = (dateB.getMonth() + 1) * 100 + dateB.getDate();

        return monthDayA - monthDayB;
    });

    const compareDates = (unixTimestamp, occasionType) => {
        const today = new Date();
        const currentMonth = today.getMonth();
        const currentDate = today.getDate();
        const givenDate = new Date(unixTimestamp);
        const givenMonth = givenDate.getMonth();
        const givenDay = givenDate.getDate();

        if (givenMonth === currentMonth && givenDay === currentDate) {
            return `${occasion[occasionType].label} Today`;
        } else if (
            givenMonth > currentMonth ||
            (givenMonth === currentMonth && givenDay > currentDate)
        ) {
            return `Upcoming ${occasion[occasionType].label}, ${new Date(unixTimestamp).toLocaleDateString("en-US", { day: 'numeric', month: 'long' })}`;
        } else {
            return `${occasion[occasionType].label} on ${new Date(unixTimestamp).toLocaleDateString("en-US", { day: 'numeric', month: 'long' })}`;
        }
    };

    /**
     * Returns true if the occasion date (day+month only, year ignored) falls within
     * the rolling 7-day window ending today (today + previous 6 days).
     * Used for Wishing button visibility only.
     */
    const isOccasionDateInWishingWindow = (occasionDate) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const windowMonthDays = new Set();
        for (let i = 0; i < 7; i++) {
            const d = new Date(today);
            d.setDate(d.getDate() - i);
            windowMonthDays.add(`${d.getMonth()}-${d.getDate()}`);
        }
        const occasion = new Date(occasionDate);
        const key = `${occasion.getMonth()}-${occasion.getDate()}`;
        return windowMonthDays.has(key);
    };

    const isWishAlreadySent = (item) =>
        sentWishes?.some(
            (wish) =>
                wish?.payload?.currentValues?.userIdentifier === item.userIdentifier &&
                wish?.payload?.currentValues?.occasionType === item.occasionType
        );

    const shouldShowWishingButton = (item) => {
        if (!showWishingBtn) return false;
        if (!item?.occasionType || !occasion[item.occasionType]) return false;
        if (!isOccasionDateInWishingWindow(item.occasionDate)) return false;
        if (isWishAlreadySent(item)) return false;
        return true;
    };

    const getWishTemplate = async (notificationReceiver) => {
        setMailBodyLoading(true)
        try {
            const result = await strapiService.getTemplate(occasion[notificationReceiver?.occasionType].template, organizationIdentifier);
            const body = result.data[0].attributes.email_body.replace("{receiverName}", notificationReceiver?.fullName)
            setMailBody(body);
            setMailSignature(`Best Wishes,\n${user?.givenName} ${user?.familyName}\n${user?.jobTitle}`)
            const subject = result.data[0].attributes.email_subject.replace("{receiverName}", notificationReceiver?.fullName)
            setMailSubject(subject);
            setFcmBody(result.data[0].attributes.fcm_notification_body)
            const title = result.data[0].attributes.fcm_title.replace("{receiverName}", notificationReceiver?.fullName)
            setFcmTitle(title)
            setSmsMessage(result.data[0].attributes.sms_message)
            setAppId(result.data[0].attributes.fcm_appId)
            setClickAction(result.data[0].attributes.clickAction)
        } catch (error) {
            ErrorNotificationComponent(error);
        } finally {
            setMailBodyLoading(false)
        }
    };

    const handleWishingButtonClick = (item) => {
        setOccasionType(item?.occasionType)
        getWishTemplate(item);
        setModalOpen(true);
        setReceiver(item);
    }

    const sendNotification = async () => {
        const message = {
            type: "text",
            message: fcmBody,
        }
        const payload = {
            sender: user?.userIdentifier,
            senderType: "workforce",
            message: JSON.stringify(message),
            metadata: "",
            organizationIdentifier,
            recipients: [
                {
                    recipient: receiver?.userIdentifier,
                    recipientType: "workforce",
                    metadata: "",
                },
            ],
            keywords: [
                {
                    keyword: "notification",
                    metadata: "",
                },
            ],
        };
        await apiService.post(
            "niramayafoundation/api/v1/communication/message",
            payload
        );
    };

    const handleSendMail = async () => {
        const payload = birthdayNotificationpayload(receiver, mailSubject, mailBody, mailSignature, fcmBody, fcmTitle, smsMessage, user?.userIdentifier, organizationIdentifier, appId, clickAction)
        await executeIntent(
            IntentType.SEND_NOTIFICATION,
            payload, {}
        );
    }

    const handleSendBtn = () => {
        handleSendMail()
        publishEvent(occasion[occasionType].eventType, user, receiver)
        sendNotification()
        setModalOpen(false);
        notification.success({
            message: `Your ${occasionType} wishes are on their way!`,
            placement: "bottomRight",
        });
        setRefresh((prev) => !prev);
    }

    const handleNameClick = (item) => {
        const userType = {
            "Volunteer Coordinator": "volunteer",
            "Volunteer": "volunteer",
            "Patient": "patient",
        }
        navigate(RoleToLinkMapper(role) + userType[item?.jobTitle] + "-profile?identifier=" + item?.userIdentifier);
    }

    useEffect(() => {
        const getPreferences = async () => {
            const payload = {
                intent: "get_configuration",
                payload: {
                    configurationKey: ["niramaya.occasion.data.preference"],
                },
                context: {
                    organizationIdentifier,
                },
            };
            try {
                const result = await performPostRequest(
                    getApiUrl()[IntentType.GET_CONFIGURATION],
                    JSON.stringify(payload)
                );
                const response = await result.json();
                const parsedPreferences = JSON.parse(response[0].configurationValue || "{}");
                setPreferences(parsedPreferences);
            } catch (err) {
                console.error(err)
            }
        };

        getPreferences();
    }, [organizationIdentifier]);

    useEffect(() => {
        const getOccasionData = async () => {
            const payload = {
                organizationIdentifier: organizationIdentifier,
                start_date: convertDateToSODTimestamp(dateRange[0].startDate),
                end_date: convertDateToEODTimestamp(dateRange[0].endDate),
                timezone: getCurrentTimeZone(),
                teamIds: teams.map(team => team?.id),
                roles: preferences?.roles || [],
                types: preferences?.types || []
            };

            setLoading(true)
            try {
                const result = await performPostRequest(getApiUrl()[IntentType.GET_OCCASION_DATA], JSON.stringify(payload));
                const resultJson = await result.json();
                setOccasionData(resultJson)
            } catch (error) {
                ErrorNotificationComponent(error);
            } finally {
                setLoading(false)
            }
        };

        if (preferences) {
            getOccasionData();
        }

    }, [teams, organizationIdentifier, dateRange, preferences?.roles, preferences?.types, preferences]);

    useEffect(() => {
        const getSentWish = async () => {
            try {
                const payload = {
                    connections: {
                        organizationIdentifier
                    },
                    from: convertDateToSODTimestamp(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)),
                    to: convertDateToEODTimestamp(Date.now()),
                    types: ["niramaya.birthday.wish", "niramaya.anniversary.wish"],
                    pageNumber: 0,
                    pageSize: 1000,
                };

                const intentExecutor = new IntentExecutor();
                const result = await intentExecutor.executeApiCall(
                    `${getApiUrl()["get_sent_wish"]}`,
                    payload
                );

                if (result?.results) {
                    setSentWishes(result?.results);
                }
            } catch (error) {
                ErrorNotificationComponent(error);
            }
        };

        getSentWish()
    }, [organizationIdentifier, refresh])

    useEffect(() => {
        // access control for wishing button
        const configurationShowWishingBtn = configuration[ConfigurationConstants.FEATUREACCESS_HOMEPAGE_STAYCONNECTED_WISHINGBUTTON]
        setShowWishingBtn(configurationShowWishingBtn?.visibility)
    }, [configuration])


    const modalButtons = (
        <>
            <SecondaryButton buttonText={strings.CANCEL} handleOnClick={() => setModalOpen(false)} />
            {
                mailBody && mailSignature &&
                <PrimaryButton buttonText={strings.SEND} handleOnClick={handleSendBtn} />
            }
        </>
    )

    return (
        <div className="col-12 col-md-6 col-lg-6 col-xl-6 mb-4">
            <Card style={{ padding: "1rem" }} className='listCardStylingSecondRow'>
                <Card.Title className='volunteersPerformanceCardTitle'>
                    Stay Connected
                </Card.Title>

                <hr style={{ marginBlock: '6px', opacity: '0.15' }} />
                {loading && <Spin size="medium" className="d-flex justify-content-center m-auto" />}
                {!loading && sortedBirthDays?.length === 0 ? (
                    <p style={{ textAlign: 'center', margin: '1rem 0' }}>No Occasions!</p>
                ) : (
                    <>
                        <List
                            itemLayout="horizontal"
                            dataSource={sortedBirthDays}
                            style={{ overflowY: 'scroll' }}
                            renderItem={(item, index) => (
                                <List.Item key={index}>
                                    <List.Item.Meta
                                        avatar={<Avatar className='occasion-avatar-background'><Initials value={item.fullName} /></Avatar>}
                                        title={
                                            <span onClick={() => handleNameClick(item)}>
                                                {item.fullName} <p style={{ float: 'right', paddingRight: "10px" }}>{compareDates(item.occasionDate, item.occasionType)}</p>
                                            </span>
                                        }
                                        description={
                                            <>
                                                {item.jobTitle}
                                                {
                                                    shouldShowWishingButton(item) && (
                                                        <div className='mt-1'>
                                                            <Button type="primary" onClick={() => handleWishingButtonClick(item)}>{occasion[item?.occasionType].buttonLabel}</Button>
                                                        </div>
                                                    )
                                                }

                                                {sentWishes?.some((wish) => wish?.payload?.currentValues?.userIdentifier === item.userIdentifier && wish?.payload?.currentValues?.occasionType === item.occasionType) && (
                                                    <div>
                                                        {occasion[item?.occasionType].label} wish sent successfully!
                                                    </div>
                                                )}
                                            </>
                                        }
                                    />
                                </List.Item>
                            )}
                        />
                    </>
                )}
            </Card>

            {modalOpen &&
                <CustomModal title={<>Wish <b>{receiver?.fullName}</b> {` ${occasion[occasionType].modalTitle}`}</>} isModalOpen={modalOpen} closeModal={setModalOpen} cssClassName="birthday-wish-modal" footer={[modalButtons]}>
                    {
                        mailBodyLoading ? (
                            <Spin size="medium" className="d-flex justify-content-center m-auto" />
                        ) : (
                            <>
                                <div className='mb-1 font-weight-bold' >Subject</div>
                                <TextArea defaultValue={mailSubject} onChange={(e) => setMailSubject(e.target.value)} />

                                <div className='mt-3 mb-1 font-weight-bold' >Text</div>
                                <TextArea defaultValue={mailBody} onChange={(e) => setMailBody(e.target.value)} />

                                <div className='mt-3 mb-1 font-weight-bold'>Signature</div>
                                <TextArea defaultValue={mailSignature} onChange={(e) => setMailSignature(e.target.value)} />
                            </>
                        )
                    }
                </CustomModal>}
        </div>
    )
}

export default StayConnected